import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import * as actions from '../../../../store/actions/index';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

const SchottForm = (props) => {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [schottId, setSchottId] = useState('');
  const [showErrorFlag, setShowErrorFlag] = useState(false);

  const errorOnLoad = useSelector(state => state.wizard.sharedSolution.errorOnLoad );

  const showError = errorOnLoad && showErrorFlag

  const infoBoxCss = {
    backgroundColor: "#fbf1e0",
    height: "auto"}

  const handleChange = (e) => {
      setSchottId(e.target.value)
      setShowErrorFlag(false)
  }

  const onSubmit = id => {
    const data = id;
    return () => dispatch( actions.fetchProductSolutionByUid(data)).then(setShowErrorFlag(true))
  } ;

  const errorText = () => {
    if (localStorage.getItem('token') !== undefined && localStorage.getItem('token') !== null) {
      return t('error1.wizard.schottuid')
    } else {
      return t('error2.wizard.schottuid')
    }
  }
  return(
    <div className="col-lg-11 col-xl-11 px-3 ">
      <div className="row">
        <div className="col-12 col-md-10 px-3 wizzard-btn " style={infoBoxCss}>
          { t('wizard.schottuid.label1') }
          <input type="text" value={schottId} onChange={(e)=>handleChange(e)} placeholder={ t('wizard.schottuid.placeholder') } style={{textAlign: "center", marginLeft: "10px", padding: "5px"}}/>
          <button type="button" onClick={ onSubmit(schottId) } className="btn-dashboard">{ t('wizard.schottuid.btn.label') }</button>
          { (showError)? <div className="alert alert-danger">{ errorText() }</div> : null }
        </div>
      </div>
    </div>
 );
};

export default SchottForm;



// WEBPACK FOOTER //
// ./src/components/Wizard/Steps/WizardStepCountry/SchottForm.js